import sessionCouldHaveNewScoringData from "../sessionContents/sessionCouldHaveNewScoringData.js";
import gameOrScrimmageSessionType from "../sessionType/gameOrScrimmage.js";
import sessionClassifierBuilder from "./sessionClassifierBuilder.js";

const sessionWithNewScoring = sessionClassifierBuilder(
    gameOrScrimmageSessionType, sessionCouldHaveNewScoringData, undefined
);

export default sessionWithNewScoring;